import(/* webpackMode: "eager" */ "/vercel/path0/src/app/search/page.js");
